(() => {
  if (customElements.get('spot-shipping-copy')) return;
  class SpotShippingCopy extends HTMLElement {
    update(cart) {
      const items = cart.items || [];
      const hasSticker = items.some(item => item.product_type === 'Sticker');
      const stickerOnly = hasSticker && items.every(item => item.product_type === 'Sticker');
      const headline = this.querySelector('[data-shipping-headline]');
      const detail = this.querySelector('[data-shipping-detail]');
      if (!headline || !detail) return;
      if (stickerOnly) headline.textContent = this.dataset.stickerHeadline;
      else headline.replaceChildren(this.querySelector('template').content.cloneNode(true));
      detail.hidden = !hasSticker;
      detail.textContent = stickerOnly ? this.dataset.stickerDetail : hasSticker ? this.dataset.mixedDetail : '';
    }
  }
  customElements.define('spot-shipping-copy', SpotShippingCopy);
  class SpotCartShipping extends HTMLElement {
    connectedCallback() { this.syncProgress(); }
    syncProgress() {
      const container = this.closest('main-cart, cart-drawer');
      if (container) container.dataset.spotStickerOnly = this.dataset.stickerOnly;
    }
    update(cart) {
      const items = cart.items || [];
      const hasSticker = items.some(item => item.product_type === 'Sticker');
      const stickerOnly = hasSticker && items.every(item => item.product_type === 'Sticker');
      this.dataset.stickerOnly = String(stickerOnly);
      const target = this.querySelector('[data-cart-note-content]');
      const source = this.querySelector(stickerOnly ? '[data-sticker-note]' : '[data-mixed-note]');
      target.replaceChildren(...(hasSticker ? [source.content.cloneNode(true)] : []));
      this.syncProgress();
    }
  }
  customElements.define('spot-cart-shipping', SpotCartShipping);
  let revision = 0;
  document.addEventListener('cart:update', async () => {
    if (!document.querySelector('spot-shipping-copy[data-cart-context], spot-cart-shipping')) return;
    const current = ++revision;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (current !== revision) return;
      document.querySelectorAll('spot-shipping-copy[data-cart-context], spot-cart-shipping').forEach(element => element.update(cart));
    } catch {}
  });
})();
